export default "__VITE_ASSET__vImfohoA__"